import styled from 'styled-components';
import { Loader as LoaderComponent, Text as TextComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.color.sidebarBorder};
  background-color: ${(props) => props.theme.color.white};
  padding: 30px;
  padding-left: 50px;
  border-radius: 4px;
`;

export const Loader = styled(LoaderComponent)`
  &&& {
    margin: auto;
  }
`;

export const Title = styled(TextComponent.Title)`
  &&& {
    padding-bottom: 10px;
  }
`;

export const Subtitle = styled(TextComponent)`
  &&& {
    padding-bottom: 15px;
  }
`;

export const Image = styled.img`
  max-height: 100%;
  max-width: 100%;
  min-height: 100%;
  min-width: 100%;
`;
